import { useMutation, useQueryClient } from "@tanstack/react-query";

import { httpClient } from "@/api/client";
import { getQueryKeyByGroupId } from "@/hooks/use-comment";

export function useModerateCommentMutation({
  groupId,
}: {
  groupId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      commentId,
      hide,
    }: {
      commentId: string;
      hide: boolean;
    }) =>
      httpClient.paths[
        `/v1/comment-groups/{groupId}/comments/{commentId}/${hide ? "hide" : "unhide"}`
      ].post({
        commentId,
        groupId,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: getQueryKeyByGroupId(groupId),
      }),
  });
}
